export function SourceBadge({ source }: { source?: string }) {
	if (source !== "mirror" && source !== "api") {
		return null
	}
	return <span title="Automated post">{"\u{1F916}"}</span>
}
